import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=03a8814c"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopNavBar: require('/app/components/Theme2/Desktop/NavBar.vue').default,Theme2MobileNavBar: require('/app/components/Theme2/Mobile/NavBar.vue').default})
